import { Model } from '@vuex-orm/core'
import MZLocation from './MZLocation'
import MZLocationable from './MZLocationable'

export default class MZInterestCategory extends Model {
  static entity = 'mzinterestcategories'
  static primaryKey = 'id'

  static fields () {
    return {
      id: this.string(''),
      name: this.string(''),
      age_min: this.string(''),
      locations: this.morphToMany(MZLocation, MZLocationable, 'location_id', 'locationable_id', 'locationable_type')
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/MZInterestCategory.js